<template>
    <div>
        <div class="agwMonitor-title">
            <div>{{$t('alarms.network.AppGateway.title')}}</div>
            <div>
                <Button type="primary" @click="addOrUpdateHandle" v-hasPermission="['network:agwMonitor:add_alert_rule']">{{$t('alarms.network.AppGateway.addAppGatewayAlarm')}}</Button>
                <add-or-update-agw-warning v-if="addOrUpdateVisible" ref="addOrUpdate"></add-or-update-agw-warning>
            </div>
        </div>
        <template>
            <Tabs size="small" :animated="false">
                <TabPane :label="$t('alarms.network.AppGateway.title')">
                    <div class="agwMonitor-top">
                        <agw-monitor-search></agw-monitor-search>
                    </div>
                    <table-agw></table-agw>
                </TabPane>
            </Tabs>
        </template>

    </div>
</template>

<script>
    import AgwMonitorSearch from '../agw/AgwMonitorSearch'
    import TableAgw from '../agw/TableAgw'
    import AddOrUpdateAgwWarning from '../agw/AddOrUpdateAgwWarning'

    export default {
        name: 'AgwMonitor',
        components: {
            AgwMonitorSearch,
            TableAgw,
            AddOrUpdateAgwWarning
        },
        data(){
            return {
                addOrUpdateVisible:false
            }
        },
         methods:{
            // 添加报警规则
            /**********************************************************************************/
            addOrUpdateHandle:function(){
                this.addOrUpdateVisible=true;
                this.$nextTick(() => {
                    this.$refs.addOrUpdate.init()
                })
            }
        }
    }
</script>

<style scoped>
    .agwMonitor-title
    {
        width: 100%;
        font-size: 13px;
        -webkit-box-sizing: border-box;
        box-sizing: border-box;
        padding: 15px 0px 0px 4px;
        font-weight: 600;
        overflow: hidden;
    }
    .agwMonitor-title>div:nth-child(1)
    {
        float:left;
    }
    .agwMonitor-title>div:nth-child(2)
    {
        float:right;
        margin-top: -6px;
    }
    .agwMonitor-top
    {
        width: 100%;
        height: 32px;
        margin-bottom: 14px;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/network/agw/AgwMonitor.vue